import { gql } from '@apollo/client';

const UPDATE_USER_SETTING_PLI_ONBOARDING_WELCOME = gql`
  mutation updateUserSettingPliOnboardingWelcome($data: PliUserOnboardingWelcomeDataInput!) {
    updateUserSettingPliOnboardingWelcome(data: $data) {
      setting
      value
    }
  }
`;

export default UPDATE_USER_SETTING_PLI_ONBOARDING_WELCOME;
